import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LayoutComponent} from './base/layout/layout.component';
import {NotFoundComponent} from './not-found/not-found.component';
import {RentalAgreementComponent} from './rental-agreement/rental-agreement.component';
import {PrivacyPolicyComponent} from './privacy-policy/privacy-policy.component';
import {LicenseAgreementComponent} from './license-agreement/license-agreement.component';
import {RulesOfUseComponent} from './rules-of-use/rules-of-use.component';
import {InsuranceComponent} from './insurance/insurance.component';
import {KzLayoutComponent} from './busy-fly-kz/kz-layout/kz-layout.component';
import {BaseLayoutComponent} from './base/base-layout/base-layout.component';
import {ByLayoutComponent} from './busy-fly-by/by-layout/by-layout.component';
import {PartsComponent} from './parts/parts.component';
import {PaymentInformationComponent} from './payment-information/payment-information.component';
import {DocumentsComponent} from './documents/documents.component';
import {KgLayoutComponent} from './busy-fly-kg/by-layout/kg-layout.component';
import {RuLayoutComponent} from './busy-fly-ru/ru-layout/ru-layout.component';
import {BaseRuLayoutComponent} from './busy-fly-ru/base-ru-layout/base-ru-layout.component';
import {RequisitesRuComponent} from './busy-fly-ru/requisites-ru/requisites-ru.component';
import {DrivingRulesComponent} from './driving-rules/driving-rules.component';
import {HowToRideComponent} from './how-to-ride/how-to-ride.component';
import {PublicOfferCourierComponent} from './public-offer-courier/public-offer-courier.component';
import {ElectricScootersRentalAgreementComponent} from './electric-scooters-rental-agreement/electric-scooters-rental-agreement.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: LayoutComponent,
        children: [
          {
            path: '',
            component: BaseLayoutComponent,
          },
          {
            path: 'kz',
            component: KzLayoutComponent,
          },
          {
            path: 'kg',
            component: KgLayoutComponent,
          },
          {
            path: 'by',
            component: ByLayoutComponent,
          },
        ]
      },
      {
        path: 'ru',
        component: BaseRuLayoutComponent,
        children: [
          {
            path: '',
            component: RuLayoutComponent,
          },
          {
            path: 'rekvizity-partnyorov',
            component: RequisitesRuComponent,
          },
        ]
      },
      {
        path: 'rental-all',
        component: DocumentsComponent,
        children: [
          {
            path: '',
            component: RentalAgreementComponent,
          }
        ]
      },
      {
        path: 'public-offer-courier',
        component: DocumentsComponent,
        children: [
          {
            path: '',
            component: PublicOfferCourierComponent,
          }
        ]
      },
      {
        path: 'electric-scooters-rental-agreement',
        component: DocumentsComponent,
        children: [
          {
            path: '',
            component: ElectricScootersRentalAgreementComponent,
          }
        ]
      },
      {
        path: 'privacy-all',
        component: DocumentsComponent,
        children: [
          {
            path: '',
            component: PrivacyPolicyComponent,
          }
        ]
      },
      {
        path: 'license-all',
        component: DocumentsComponent,
        children: [
          {
            path: '',
            component: LicenseAgreementComponent,
          }
        ]
      },
      {
        path: 'terms-of-use',
        component: DocumentsComponent,
        children: [
          {
            path: '',
            component: RulesOfUseComponent,
          }
        ]
      },
      {
        path: 'insurance',
        component: DocumentsComponent,
        children: [
          {
            path: '',
            component: InsuranceComponent,
          }
        ]
      },
      {
        path: 'parts',
        component: DocumentsComponent,
        children: [
          {
            path: '',
            component: PartsComponent,
          }
        ]
      },
      {
        path: 'payment-information',
        component: DocumentsComponent,
        children: [
          {
            path: '',
            component: PaymentInformationComponent,
          }
        ]
      },
      {
        path: 'driving-rules',
        component: DocumentsComponent,
        children: [
          {
            path: '',
            component: DrivingRulesComponent,
          },
        ]
      },
      {
        path: 'how-to-ride',
        component: HowToRideComponent,
      },
    ]
  },
  {
    path: '404',
    component: NotFoundComponent,
  },
  {path: '**', redirectTo: '/404'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes), RouterModule.forRoot(routes, {scrollPositionRestoration: 'top'})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
